export default __webpack_public_path__ + "resources/icons/n210-774b.png";